import { createGlobalStyle } from "styled-components";

// 외부에서 import 할거니까 모듈 내보내자~!
export const GlobalStyle = createGlobalStyle`
  /* 그밖에 글로벌 스타일 작성하기  */
  /* * { font-family: 'Spoqa Han Sans Neo', sans-serif; } */

  @font-face {
    font-family: 'KBO-Dia-Gothic_bold';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2304-2@1.0/KBO-Dia-Gothic_bold.woff') format('woff');
    font-weight: 700;
    font-style: normal;
  } 
  
  @font-face {
    font-family: 'GangwonEduHyeonokT_OTFMediumA';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2201-2@1.0/GangwonEduHyeonokT_OTFMediumA.woff') format('woff');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'iceSotong-Rg';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2307-2@1.0/iceSotong-Rg.woff2') format('woff2');
    font-weight: normal;
    font-style: normal;
}
  * {
    margin: 0;
    padding: 0;

    box-sizing: border-box;
  }
  body {
      font-family: "iceSotong-Rg";

    margin: 0;
    padding: 0;
    overflow-y: scroll;

    box-sizing: border-box;  background-color: black;


  }

  h1, h2, h3, h4, h5, h6 {
    margin: 0;
  }
`;
